import { Avatar, Pagination } from "antd";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Table, Button } from "reactstrap";
import { FiEdit2, FiEye, FiTrash2 } from "react-icons/fi";
import NotFoundDataUI from "../cards/NotFoundDataUI";
import DeleteModal from "../modals/DeleteModal";

const CategoriesTable = ({
    toggle,
    data,
    handleDelete,
    setSelectedCategory,
    onClearSearch,
}) => {
    const history = useHistory();
    const { user } = useSelector((state) => state.auth);
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [pageSize, setPageSize] = useState(50);

    useEffect(() => {
        setCurrentPage(1);
    }, [data?.length]);

    const paginatedData = data?.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <div>
            <Table
                responsive
                hover
                bordered
                className="mb-0"
                style={{
                    fontSize: "15px",
                    overflow: "hidden",
                    border: "1px solid #e2e8f0"
                }}
            >
                <thead>
                    <tr style={{ backgroundColor: "#00509d", color: "white" }}>
                        <th className="text-center" style={{ borderBottom: "none" }}>ID</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>Image</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>Category Name</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>Type</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>Identifiers</th>
                        <th className="text-center" style={{ borderBottom: "none" }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedData && paginatedData.length > 0 ? paginatedData.map((category, index) => (
                        <tr
                            key={index}
                            className="align-middle"
                            style={{
                                backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                                borderBottom: "1px solid #f1f5f9"
                            }}
                        >
                            <td className="text-center text-muted">
                                {category?.id || (currentPage - 1) * pageSize + index + 1}
                            </td>
                            <td className="text-center">
                                <Avatar
                                    src={category?.categoryImage ?? category?.categoryImageURL}
                                    size={32}
                                    className="shadow-sm border"
                                />
                            </td>
                            <td className="text-center fw-bold">
                                {category?.categoryName}
                            </td>
                            <td className="text-center">
                                <span className="user-badge bg-primary-soft">
                                    {category?.categoryType || "Standard"}
                                </span>
                            </td>
                            <td className="text-center">
                                <div className="text-uppercase small text-muted">
                                    {category?.identifiers && category.identifiers.length > 0
                                        ? category.identifiers.join(", ")
                                        : "techmicro"}
                                </div>
                            </td>
                            <td className="text-center">
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <Button
                                        color="link"
                                        className="p-1 border-0"
                                        onClick={() => {
                                            setSelectedCategory(category);
                                            toggle();
                                        }}
                                        title="Edit Category"
                                    >
                                        <FiEdit2 className="text-primary" size={14} />
                                    </Button>
                                    <Button
                                        color="link"
                                        className="p-1 border-0"
                                        onClick={() => {
                                            history.push({
                                                pathname: `/admin/category-details/${category?._id}`,
                                                state: category,
                                            });
                                        }}
                                        title="View Details"
                                    >
                                        <FiEye className="text-info" size={18} />
                                    </Button>
                                    {(user?.role === "Admin" || user?.role === "Super-admin") && (
                                        <Button
                                            color="link"
                                            className="p-1 border-0"
                                            onClick={() => {
                                                setItemToDelete(category?._id);
                                                setDeleteModalOpen(true);
                                            }}
                                            title="Delete Category"
                                        >
                                            <FiTrash2 className="text-danger" size={16} />
                                        </Button>
                                    )}
                                </div>
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan="6" className="text-center py-4">
                                <NotFoundDataUI 
                                    message="No categories found!" 
                                    onClearSearch={onClearSearch}
                                />
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
            {data && data.length > 0 && (
                <div className="d-flex justify-content-end p-3 bg-white border-top border-start border-end border-bottom">
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={data.length}
                        onChange={(page) => setCurrentPage(page)}
                        showSizeChanger={true}
                        onShowSizeChange={(current, size) => {
                            setPageSize(size);
                            setCurrentPage(1);
                        }}
                        pageSizeOptions={['10', '25', '50', '100']}
                    />
                </div>
            )}
            <DeleteModal 
                modal={deleteModalOpen} 
                toggle={() => setDeleteModalOpen(false)} 
                handleDelete={() => {
                    handleDelete(itemToDelete);
                    setDeleteModalOpen(false);
                }} 
            />
        </div>
    );
};


export default CategoriesTable;
